import { GridCustomCellProps } from '@progress/kendo-react-grid';
import * as React from 'react';
import { parseJSON } from 'date-fns';
import { format } from 'date-fns-tz';
import { ViewModel } from '.';

const DeliveryCell = (props: GridCustomCellProps) => {
  const data = props.dataItem as ViewModel;
  return (
    <td {...props.tdProps}>
      {data.DeliveryLocation}<br />
      {format(parseJSON(data.DeliveryDateTime), 'LL/dd/yyyy HH:mm zzz')}
    </td>
  );
}
export default React.memo(DeliveryCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);